import React from "react";
import { Instagram, Linkedin, Apple, Play } from "lucide-react";
import { LOGO_URL } from "../../lib/assets";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-white border-t border-slate-100"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <a
                            href="#top"
                            className="flex items-center gap-3"
                            data-testid="footer-logo"
                        >
                            <img
                                src={LOGO_URL}
                                alt="Dentro"
                                className="h-10 w-10 rounded-lg object-cover"
                            />
                            <span className="font-display text-2xl font-extrabold text-[#0B1C3A]">
                                Dentro
                            </span>
                        </a>
                        <p className="mt-4 font-display text-xl font-semibold text-[#0B1C3A]/80 max-w-md">
                            O que importa, está dentro.
                        </p>
                        <div className="mt-6 flex items-center gap-2">
                            <a
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram"
                                aria-label="Instagram"
                                className="h-10 w-10 grid place-items-center rounded-full border border-slate-200 text-[#0B1C3A]/70 hover:text-white hover:bg-[#16A34A] hover:border-[#16A34A] transition-colors"
                            >
                                <Instagram size={18} />
                            </a>
                            <a
                                href="https://linkedin.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-linkedin"
                                aria-label="LinkedIn"
                                className="h-10 w-10 grid place-items-center rounded-full border border-slate-200 text-[#0B1C3A]/70 hover:text-white hover:bg-[#16A34A] hover:border-[#16A34A] transition-colors"
                            >
                                <Linkedin size={18} />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#16A34A]">
                            Aplicativo
                        </div>
                        <ul className="mt-4 space-y-3 text-[15px]">
                            <li>
                                <a
                                    href="#"
                                    data-testid="footer-ios"
                                    className="inline-flex items-center gap-2 text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    <Apple size={16} /> iOS — App Store
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    data-testid="footer-android"
                                    className="inline-flex items-center gap-2 text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    <Play size={16} /> Android — Google Play
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#como-funciona"
                                    className="text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    Como funciona
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#beneficios"
                                    className="text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    Benefícios
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#16A34A]">
                            Legal
                        </div>
                        <ul className="mt-4 space-y-3 text-[15px]">
                            <li>
                                <a
                                    href="#"
                                    data-testid="footer-termos"
                                    className="text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    Termos de uso
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/privacy"
                                    data-testid="footer-privacidade"
                                    className="text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    Política de privacidade
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:contato@dentro.app.br"
                                    data-testid="footer-contato"
                                    className="text-[#0B1C3A] hover:text-[#16A34A] font-semibold"
                                >
                                    Contato
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-slate-100">
                    <p
                        data-testid="footer-disclaimer"
                        className="text-xs text-[#475569] leading-relaxed max-w-4xl"
                    >
                        As informações apresentadas pelo Dentro são educativas e
                        não substituem orientação médica, nutricional ou
                        profissional. Em caso de alergias, condições de saúde ou
                        dúvidas específicas, procure um profissional qualificado.
                    </p>
                    <p className="mt-6 text-xs text-[#475569]">
                        © {new Date().getFullYear()} Dentro. Todos os direitos
                        reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
}
